export function _rk(...keywords: string[]) {
  return ["rk", ...keywords].filter(Boolean).join("-");
}

export function _brk(...keywords: string[]) {
  return `[${_rk(...keywords)}]`;
}

export function _brkk(value: string, ...keywords: string[]) {
  return `[${_rk(...keywords)}="${value}"]`;
}
